export const MAT_LAYOUT_COLORS = ["orange", "orangered", "yellow"];

const getWirePathLength = (points = []) => {
  let length = 0;

  for (let index = 0; index + 3 < points.length; index += 2) {
    length += Math.hypot(
      Number(points[index + 2]) - Number(points[index]),
      Number(points[index + 3]) - Number(points[index + 1])
    );
  }

  return length;
};

export const buildMatColorMap = (matData) => {
  const matParams = Object.values(matData?.matParams || {});
  const wires = matData?.calculatedData?.wires || [];

  if (matParams.length === 0 || wires.length === 0) {
    return {};
  }

  const matsByLength = matParams
    .map((mat, index) => ({ mat, index }))
    .sort(
      (left, right) =>
        Number(right.mat.WireLength) - Number(left.mat.WireLength) ||
        left.index - right.index
    );
  const wiresByLength = wires
    .map((wire, index) => ({
      index,
      length: getWirePathLength(wire.wire_points),
    }))
    .sort(
      (left, right) =>
        right.length - left.length || left.index - right.index
    );

  return matsByLength.reduce((colorsByMatId, { mat }, rank) => {
    if (!mat.MatId || !wiresByLength[rank]) {
      return colorsByMatId;
    }

    const wireIndex = wiresByLength[rank].index;
    const color = MAT_LAYOUT_COLORS[wireIndex] || "red";

    if (!colorsByMatId[mat.MatId]) {
      colorsByMatId[mat.MatId] = [];
    }
    colorsByMatId[mat.MatId].push(color);

    return colorsByMatId;
  }, {});
};

export const buildMatDisplayEntries = (matData) => {
  const matParams = Object.values(matData?.matParams || {});
  const colorsByMatId =
    matData?.matColorsById || buildMatColorMap(matData);
  const occurrencesByMatId = {};

  return matParams.map((mat, index) => {
    const occurrence = occurrencesByMatId[mat.MatId] || 0;
    occurrencesByMatId[mat.MatId] = occurrence + 1;

    return {
      mat,
      color:
        colorsByMatId[mat.MatId]?.[occurrence] ||
        MAT_LAYOUT_COLORS[index] ||
        "red",
      key: `${mat.MatId || "mat"}-${occurrence}`,
    };
  });
};
